import {NgModule} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ResourceComponent} from './resource.component';
import {ResourceService} from './resource.service';
import {ComponentsModule} from '../shared/component/components.module';
import {SearchScopeConfigurationService} from '../cache/uiconfiguration/searchscopeconfiguration.service';
import {ActionBarConfigurationService} from '../cache/uiconfiguration/actionbarconfiguration.service';
import {ResourceDetailComponent} from './detail/detail.component';
import {ControlsModule} from './detail/controls/controls.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DetailService} from './detail/detail.service';
import {ResourceDetailSummaryDialogComponent} from './detail/detail-summary-dialog.component';
import {LanguageModule} from '../language/language.module';
import {ResourceWizardComponent} from './detail/wizard.component';
import {ViewTabComponent} from './detail/viewtab.component';
import {RequestDialogComponent} from './request-approval/request-dialog.component';
import {SharedControlsModule} from '../shared/controls/controls.module';
import {TimeAgoModule} from '../shared/component/smd-timeline/TimeAgoModule';
import {PipesModule} from '../shared/pipes/pipes.module';
import {CandeactivateDialogComponent} from './detail/controls/canDeactivateGuard/candeactivate-dialog.component';
import {CsvExportDialogComponent} from './csv-export-dialog/csv-export-dialog.component';
import {HomeComponent} from './home/home.component';
import {CommonModule} from '@angular/common';
import {
  AppDialogActionButtonComponent,
  AppDialogActionButtonCustomDirective,
  AppDialogComponent,
  AppDialogHeaderButtonDirective,
  AppDialogSubtitleDirective,
  AppDialogTitleDirective,
} from '../shared/dialog/app-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    FormsModule,
    ComponentsModule,
    ControlsModule,
    SharedControlsModule,
    LanguageModule,
    TimeAgoModule,
    PipesModule,
    ReactiveFormsModule,
    AppDialogComponent,
    AppDialogTitleDirective,
    AppDialogActionButtonComponent,
    AppDialogActionButtonCustomDirective,
    AppDialogSubtitleDirective,
    AppDialogHeaderButtonDirective,
  ],

  declarations: [
    ResourceComponent,
    ResourceDetailComponent,
    ResourceDetailComponent,
    ViewTabComponent,
    ResourceWizardComponent,
    ResourceDetailSummaryDialogComponent,
    RequestDialogComponent,
    CandeactivateDialogComponent,
    CsvExportDialogComponent,
    HomeComponent,
  ],
  exports: [],
  providers: [
    DetailService,
    ResourceService,
    SearchScopeConfigurationService,
    ActionBarConfigurationService,
    Title,
  ],
})
export class ResourcesModule {}
